import { MDXRemote } from 'next-mdx-remote/rsc';
import { PostContent as PostContentType } from '../../types/blog';

interface PostContentServerProps {
  post: PostContentType;
}

export default function PostContentServer({ post }: PostContentServerProps) {
  return (
    <article className="prose mx-auto p-6 max-w-none">
      <h1 className="text-3xl md:text-4xl font-bold mb-4">{post.meta.title}</h1>
      {post.meta.date && post.meta.author && (
        <p className="text-gray-500 mb-8">{post.meta.date} — {post.meta.author}</p>
      )}
      
      <div className="blog-content">
        <MDXRemote source={post.content} />
      </div>
    </article>
  );
} 